import React, { useRef, useState, useEffect } from "react";
import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react";
import { FaTimes } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa6";
import { RiImageAddLine } from "react-icons/ri";
import { HiMapPin } from "react-icons/hi2";
import { useDispatch, useSelector } from "react-redux";
import LocationModal from "./LocationModal";
import { setEventData } from "../../redux/posts/posts.action";
import { nextPowerTwo } from "add";
import { getGoogleLocation } from "../../utils/utils";

const CreateEvent = ({
  isOpen,
  previous,
  setShowModal,
  onClose,
  showPreview,
}) => {
  const [, setImage] = useState({});
  const [imageArray, setImageArray] = useState([]);
  const { eventData, activeLocation } = useSelector((state) => state.posts);
  const inputRef = useRef(null);
  const textRef = useRef(null);
  const titleRef = useRef(null);
  const [value, setValue] = useState({
    text: "",
    title: "",
  });
  const dispatch = useDispatch();
  const darktheme = useSelector((state) => state.features.settings.darktheme);
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [currentLocation, setCurrentLocation] = useState({
    longitude: null,
    latitude: null,
  });
  const onHandleChange = (e) => {
    e.preventDefault();
    setValue({
      ...value,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const { lat, lng } = await getGoogleLocation();
        setCurrentLocation({
          latitude: lat,
          longitude: lng,
        });
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };
  
    fetchLocation();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(
      setEventData({
        ...value,
        latitude: currentLocation?.latitude,
        longitude: currentLocation?.longitude,
        imageArray: imageArray,
      })
    );
    // eslint-disable-next-line
  }, [value, imageArray, currentLocation]);

  const handleFocus = (event) => {
    if (event.key === "Enter") {
      textRef.current.focus();
    }
  };

  const handleFileChange = (e) => {
    setImage(e.target.files[0]);
    setImageArray([...imageArray, e.target.files[0]]);
  };

  const handleUploadImage = (e) => {
    e.preventDefault();
    inputRef.current.click();
  };

  const selectLocation = () => {
    setLocationModalOpen(true);
  };

  const closaLocationModal = () => {
    setLocationModalOpen(false);
    nextPowerTwo();
  };

  return (
    <>
      <Modal
        className="w-full"
        size={"lg"}
        isOpen={isOpen}
        onClose={() => setShowModal()}
        onOverlayClick={() => setShowModal(false)}
      >
        <ModalOverlay />
        <ModalContent
          className={` max-w-[552px]   ${
            darktheme ? "bg-kdark3 " : "bg-white"
          }`}
          containerProps={{
            justifyContent: "center",
            alignItems: "center",
            background: `${darktheme ? "bg-kdark3 " : "bg-white"}`,
          }}
          borderRadius={20}
        >
          <div
            className={`${
              darktheme ? "bg-kdark3 rounded-[16px]" : "bg-white rounded-[20px]"
            } h-full py-[22px]`}
          >
            <div className={`flex  px-[20px] relative items-center w-full `}>
              {previous ? (
                <div
                  onClick={onClose}
                  className="w-[36px] absolute cursor-pointer  h-[36px] float-left bg-[#ffffff] border-[.1px] rounded-full my-[1rem]  justify-center flex items-center"
                >
                  <FaArrowLeft
                    size={12}
                    className="float-left text-[#050558]"
                  />
                </div>
              ) : (
                <div
                  onClick={setShowModal}
                  className={`w-[36px] absolute cursor-pointer  h-[36px] float-left ${
                    darktheme ? "bg-black text-[#888a8b] " : "bg-white "
                  } border-[.1px] rounded-full my-[rem]  justify-center flex items-center`}
                >
                  <FaTimes
                    size={12}
                    className={`float-left text-[#050558] ${
                      darktheme ? "text-[#888a8b] " : "text-[#050558] "
                    }`}
                  />
                </div>
              )}
              <h4
                className={`text-center mx-auto  font-[500] text-[14px] ${
                  darktheme ? "text-[#888a8b]" : "text-[#FC5059]"
                }`}
              >
                Create Event
              </h4>
            </div>
            <ModalBody className="mt-[16px]  w-full">
              {locationModalOpen ? (
                <LocationModal
                  isOpen={locationModalOpen}
                  onClose={closaLocationModal}
                />
              ) : (
                <div className="w-full relative ">
                  <input
                    name="title"
                    placeholder="What's happening..."
                    className={`w-full font-[500] text-[24px]   ${
                      darktheme ? "text-[#888a8b]" : "text-[#0A0D14]"
                    } bg-transparent placeholder:text-[#718096] mb-[1rem] outline-none`}
                    value={eventData?.title}
                    onChange={(e) => onHandleChange(e)}
                    onKeyDown={handleFocus}
                    ref={titleRef}
                  />
                  <textarea
                    className={`w-full h-[70px] font-[400] bg-transparent text-[16px] ${
                      darktheme ? "text-[#888a8b]" : "text-[#718096]"
                    }    outline-none`}
                    placeholder="Add more details about your event (optional)..."
                    value={eventData?.text}
                    name="text"
                    ref={textRef}
                    onChange={(e) => onHandleChange(e)}
                  ></textarea>
                  <div className="flex my-[16px] items-center gap-2 font-[400]">
                    <button
                      onClick={() => selectLocation()}
                      className={`flex gap-[4px]   py-[6px]  px-[10px] text-[#586f94] font-[400] text-[14px] h-[32px] ${
                        darktheme ? "bg-[#ffff3B0D] " : "bg-[#00003B0D] "
                      }  cursor-pointer rounded-[999px] items-center `}
                    >
                      <HiMapPin className="text-[#4A4A4A]  w-[16px] h-[16px]" />{" "}
                      {activeLocation
                        ? activeLocation.slice(0, 19) + "..."
                        : "Location"}
                    </button>
                    <button
                      className={`flex gap-[4px] h-[32px] appearance-none cursor-pointer  w-[px] py-[6px]  px-[10px]  rounded-[999px] items-center text-[#586f94]  ${
                        darktheme ? "bg-[#ffff3B0D] " : "bg-[#00003B0D] "
                      } font-[400]  text-[12px] `}
                    >
                      <input
                        type="date"
                        name="date"
                        placeholder="date"
                        value={eventData?.date}
                        onChange={(e) => onHandleChange(e)}
                        className=" bg-transparent w-[90px] cursor-pointer focus:outline-none border-none"
                      />
                    </button>
                    <button
                      className={`flex gap-[px] h-[32px]  cursor-pointer   py-[6px]  px-[10px]  rounded-[999px] items-center text-[#586f94]  ${
                        darktheme ? "bg-[#ffff3B0D] " : "bg-[#00003B0D] "
                      } font-[400]  text-[12px] `}
                    >
                      <input
                        type="time"
                        name="time"
                        value={eventData?.time}
                        placeholder="date"
                        onChange={(e) => onHandleChange(e)}
                        className=" bg-transparent w-[69px] cursor-pointer text-[14px]  focus:outline-none border-none"
                      />
                    </button>
                  </div>
                  {imageArray?.length === 0 ? (
                    <div
                      className={`  ${
                        darktheme ? "bg-[#888a8b] " : "bg-[#F6F8FA] "
                      } my-[12px] h-[209px] w-full flex items-center justify-center rounded-[8px]`}
                    >
                      <div className="text-center ">
                        <input
                          type="file"
                          className="hidden"
                          onChange={handleFileChange}
                          accept="image/*, jpeg/*  png/* "
                          ref={inputRef}
                        />
                        <button
                          onClick={(e) => handleUploadImage(e)}
                          className="flex justify-center cursor-pointer item-center bg-white border-[1px] p-[10px]   mx-auto border-[#E2E4E9] rounded-[999px] gap-[4px] w-[160px] h-[40px] "
                        >
                          <RiImageAddLine className="w-[16.5px] mt-[1.5px]  h-[15px] text-[#525866]" />
                          <span className="text-[14px] text-[#525866] font-[500] leading-[20px]">
                            Add cover photo
                          </span>
                        </button>
                        <p className="font-[500] underline text-[14px]  cursor-pointer mt-[12px] text-[#000000] ">
                          Generate cover photo based on your event title
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className=" w-full my-[12px] h-[209px]">
                      {eventData?.imageArray?.map((item, i) => (
                        <div
                          key={i}
                          className=" mr-[.5rem] w-full h-full mb-2 rounded-[10px]"
                        >
                          {item && (
                            <div className="relative rounded-[10px] h-full w-full ">
                              <img
                                src={URL.createObjectURL(item)}
                                alt="uploaded post files"
                                className="object-cover rounded-[10px] w-full h-full"
                              />
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                  <button
                    onClick={() => showPreview()}
                    disabled={
                      value?.text?.length === 0 ||
                      value.title?.length === 0 ||
                      imageArray.length === 0 ||
                      value.date?.length === 0 ||
                      value?.time === 0 ||
                      activeLocation?.length === 0
                        ? true
                        : false
                    }
                    className={`${
                      value?.text?.length === 0 ||
                      value.title?.length === 0 ||
                      imageArray.length === 0 ||
                      value.date?.length === 0 ||
                      value?.time === 0
                        ? "bg-[#b7b6b6]"
                        : "button-red-gradient"
                    }  rounded-[999px] p-[10px] w-[112px] h-[40px] my-[8px] text-[14px] text-white font-[500] float-right`}
                  >
                    Create Event
                  </button>
                </div>
              )}
            </ModalBody>
          </div>
        </ModalContent>
      </Modal>
    </>
  );
};

export default CreateEvent;
